import React from 'react'

const NotFound = () => {
    return (
        <div style={{ height: "100vh" }}>
            <div style={{ height: "100vh", margin: "auto", alignItems: 'center',  display: 'flex', flexDirection: 'column' }}>
                <img src="assets/img/something-lost.png" alt="en" width={"500"} />
                <h1>Oops, looks like the page is lost.</h1>
                <p style={{ fontSize: "22px" }} >This is not a fault, just an accident that was not intentional.</p>
            </div>
        </div>
    )
}

export default NotFound